"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentDefinitionSchema = void 0;
const zod_1 = require("zod");
const component_1 = require("./component");
exports.ComponentDefinitionSchema = zod_1.z.object({
    component: component_1.ComponentSchema,
});
//# sourceMappingURL=ComponentDefinition.js.map